import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-autorizacion-presencial-eliminar',
  standalone: false,
  templateUrl: './autorizacion-presencial-eliminar.component.html',
  styleUrls: ['./autorizacion-presencial-eliminar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutorizacionPresencialEliminarComponent implements OnInit {

  alumno: any;

  onSaveSubject = new Subject();
  onSave$ = this.onSaveSubject.asObservable();

  constructor(public dialogRef: MatDialogRef<AutorizacionPresencialEliminarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.alumno = this.data.alumno;
  }

  submit() {
    this.onSaveSubject.next('');
  }

}
